import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function BookAppointment() {
  const navigate = useNavigate();

  useEffect(() => {
    // Save intended destination so after login they come back here
    localStorage.setItem("redirectAfterLogin", "/doctors");
  }, []);

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#f0f9ff", fontFamily: "sans-serif", padding: "16px"
    }}>
      <style>{`
        .book-card { background: #fff; border-radius: 24px; padding: 48px 40px; text-align: center; box-shadow: 0 20px 60px rgba(186,230,253,0.4); max-width: 480px; width: 100%; }
        @media (max-width: 600px) {
          .book-card { padding: 32px 24px; }
        }
      `}</style>
      <div className="book-card">
        <div style={{ fontSize: "56px", marginBottom: "16px" }}>🗓️</div>
        <h2 style={{ color: "#0c4a6e", fontWeight: 800, fontSize: "24px", margin: "0 0 8px" }}>
          Book a New Appointment
        </h2>
        <p style={{ color: "#64748b", marginBottom: "32px", lineHeight: 1.6 }}>
          Your previous appointment was cancelled. Please log in to browse available doctors and book a new slot.
        </p>

        <button
          onClick={() => navigate("/login")}
          style={{
            width: "100%", padding: "14px", background: "linear-gradient(135deg, #0284c7, #0ea5e9)",
            color: "#fff", border: "none", borderRadius: "14px", fontSize: "16px",
            fontWeight: 700, cursor: "pointer", marginBottom: "12px"
          }}
        >
          Login to Book
        </button>

        <button
          onClick={() => navigate("/signup")}
          style={{
            width: "100%", padding: "14px", background: "#f0f9ff",
            color: "#0284c7", border: "2px solid #bae6fd", borderRadius: "14px",
            fontSize: "16px", fontWeight: 700, cursor: "pointer"
          }}
        >
          Create Account
        </button>
      </div>
    </div>
  );
}